// extracted by mini-css-extract-plugin
module.exports = {"savedSearchLink":"SavedSearchList_savedSearchLink__1IlA0","savedSearchLink__label":"SavedSearchList_savedSearchLink__label__1Zfu-"};